import { getUserMockedFromUrlParams } from '../../../../utils';
import { mockInstance, withDelay } from '../../../../api/axiosInstance.mock';

import { CONFIRMER_OFFRE_END_POINT } from '../../apiEndPoints';
import { CodeAvisEnumModal } from '../../../../components/codeAvis/CodeAvis.utils';
import { IConfirmerOffreResponse } from './useConfirmerOffreApi';
import { defineMockData as defineMockDataSession } from '../../contexte/useSessionApi/useSessionApi.mock';

const data: IConfirmerOffreResponse = {
    codeAvis: null,
    redirectUrl: ''
};

const defineMockData = (useMockParam: string): any => {
    if (!useMockParam) return data;
    switch (useMockParam) {
        case 'coemprunteur1codeAvisSignatureIntegreeEnCours':
            return {
                ...data,
                codeAvis: CodeAvisEnumModal.AVIS_SIGNATURE_EN_COURS
            };
        default:
            return data;
    }
};

export const useConfirmerOffreApiMock = (): any => {
    const userMockParam = getUserMockedFromUrlParams();
    const sessionMockData = defineMockDataSession(userMockParam);

    const urlWithIdOffre = new RegExp(
        `${CONFIRMER_OFFRE_END_POINT.replace(
            /{idDemande}/g,
            String(sessionMockData?.contextePret?.idDemande)
        ).replace(/{idOffre}/g, String('[0-9]+'))}`
    );

    const urlWithoutIdOffre = new RegExp(
        `${CONFIRMER_OFFRE_END_POINT.replace(
            /{idDemande}/g,
            String(sessionMockData?.contextePret?.idDemande)
        ).replace(/{idOffre}/g, String('undefined'))}`
    );

    mockInstance
        .onPut(urlWithIdOffre)
        .reply(withDelay([200, defineMockData(userMockParam)], 200));
    mockInstance
        .onPut(urlWithoutIdOffre)
        .reply(withDelay([200, defineMockData(userMockParam)], 200));
};
